module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "exportrequirementsmodal",
    attrs: {
      "id": "export-requirements-modal",
      "title": "Export all requirements",
      "name": "export-requirements-modal",
      "size": "lg",
      "busy": _vm.loading,
      "ok-title": "Export",
      "close-title": "Cancel",
      "hide-header-close": "",
      "ok-disabled": !_vm.format
    },
    on: {
      "ok": _vm.handleOk,
      "cancel": _vm.handleCancel
    }
  }, [_c('b-row', {
    staticClass: "my-1"
  }, [_c('b-col', {
    attrs: {
      "sm": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "field-formatOptions"
    }
  }, [_vm._v("Format:")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "9"
    }
  }, [_c('b-form-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "mb-3",
    attrs: {
      "id": "field-formatOptions",
      "options": _vm.formatOptions,
      "data-vv-name": "format"
    },
    model: {
      value: (_vm.format),
      callback: function($$v) {
        _vm.format = $$v
      },
      expression: "format"
    }
  })], 1)], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
    attrs: {
      "slot": "modal-ok"
    },
    slot: "modal-ok"
  }, [_c('icon', {
    attrs: {
      "name": "spinner",
      "pulse": ""
    }
  }), _vm._v(" Exporting\n  ")], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bfe82518"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/ExportRequirementsModal.vue
// module id = 1026
// module chunks = 1